import React from 'react'

const AppDataContext = React.createContext({
    appContext: {},
    setAppContext: () => {}
  });
  
  export default AppDataContext;
  
